import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { productMain } from '../images';
import { mainProduct, cheapProduct } from '../data/product';
import './cart-styles.css';

const DELIVERY_MAX_EUR = '3.99';

const Cart = () => {
    const navigate = useNavigate();
    const { cartItems, removeFromCart, updateQuantity, clearCart, addToCart } = useCart();

    const handleQuantityChange = (item, newQuantity) => {
        if (newQuantity < 1) return;
        updateQuantity(item.id, item.selectedSize, item.selectedColor, newQuantity);
    };

    const handleRemoveItem = (item) => {
        removeFromCart(item.id, item.selectedSize, item.selectedColor);
    };

    const getTotalQuantity = () => {
        return cartItems.reduce((total, item) => total + item.quantity, 0);
    };

    const getTotalPrice = () => {
        return cartItems.reduce((total, item) => total + (item.price * item.quantity), 0);
    };

    const cartHasProductId = (productId) =>
        cartItems.some((i) => i.id === productId);

    const handleAddUpsell = (product) => {
        if (product.id === mainProduct.id) {
            navigate('/premium-strap');
            return;
        }
        addToCart({
            ...product,
            selectedSize: 'N/A',
            selectedColor: 'N/A',
            quantity: 1
        });
    };

    const upsellCandidates = [mainProduct, cheapProduct].filter((p) => !cartHasProductId(p.id));

    const handleCheckout = () => {
        navigate('/checkout');
    };

    if (cartItems.length === 0) {
        return (
            <div className="cart-page">
                <h1 className="cart-title">Вашата количка</h1>
                <div className="empty-cart">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="9" cy="21" r="1"></circle>
                        <circle cx="20" cy="21" r="1"></circle>
                        <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                    </svg>
                    <p>Вашата количка е празна</p>
                    <Link to="/" className="continue-shopping">Продължете пазаруването</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="cart-page">
            <h1 className="cart-title">Вашата количка</h1>
            
            <div className="cart-container">
                <div className="cart-main-column">
                <div className="cart-items">
                    {cartItems.map((item, index) => (
                        <div className="cart-item" key={`${item.id}-${item.selectedSize}-${item.selectedColor}-${index}`}>
                            <div className="cart-item-image">
                                <img src={item.image || item.images?.[0] || productMain} alt={item.name} />
                            </div>
                            <div className="cart-item-details">
                                <h3>{item.name}</h3>
                                <div className="cart-item-options">
                                    {item.selectedSize !== 'N/A' && <p>Размер: <span>{item.selectedSize}</span></p>}
                                    {item.selectedColor !== 'N/A' && <p>Цвят: <span>{item.selectedColor}</span></p>}
                                </div>
                                <div className="cart-item-price">
                                    {item.price.toFixed(2)} €
                                </div>
                            </div>
                            <div className="cart-item-actions">
                                <div className="cart-quantity-control">
                                    <button 
                                        className="cart-quantity-btn"
                                        onClick={() => handleQuantityChange(item, item.quantity - 1)}
                                    >
                                        -
                                    </button>
                                    <span className="cart-quantity">{item.quantity}</span>
                                    <button 
                                        className="cart-quantity-btn"
                                        onClick={() => handleQuantityChange(item, item.quantity + 1)}
                                    >
                                        +
                                    </button>
                                </div>
                                <button 
                                    className="remove-item-btn"
                                    onClick={() => handleRemoveItem(item)}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="3 6 5 6 21 6"></polyline>
                                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                                        <line x1="10" y1="11" x2="10" y2="17"></line>
                                        <line x1="14" y1="11" x2="14" y2="17"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="cart-delivery-hint">
                    <p>
                        При <strong>2 или повече артикула</strong> в една поръчка доставката е <strong>безплатна</strong>.
                        При по-малко от 2 артикула доставката е <strong>до {DELIVERY_MAX_EUR} €</strong>.
                        Можеш да вземеш втори чифт за себе си или за твоя gym buddy и да спестиш доставката.
                    </p>
                </div>

                {upsellCandidates.length > 0 && (
                    <section className="cart-upsell" aria-label="Други ремъци">
                        <h2 className="cart-upsell-title">Добави и другия модел</h2>
                        <p className="cart-upsell-sub">
                            Комбинирай Фитили RP Versa Grips style и по-достъпния вариант за теб и партньора в залата.
                        </p>
                        <div className="cart-upsell-grid">
                            {upsellCandidates.map((p) => (
                                <div key={p.id} className="cart-upsell-card">
                                    <div className="cart-upsell-image">
                                        <img src={p.image} alt="" />
                                    </div>
                                    <div className="cart-upsell-info">
                                        <h3>{p.name}</h3>
                                        <p className="cart-upsell-price">{p.price.toFixed(2)} €</p>
                                        <button
                                            type="button"
                                            className="cart-upsell-btn"
                                            onClick={() => handleAddUpsell(p)}
                                        >
                                            Добави в количката
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                )}
                </div>

                <div className="cart-summary">
                    <h2>Обобщение на поръчката</h2>
                    <div className="cart-summary-row">
                        <span>Общо продукти:</span>
                        <span>{cartItems.reduce((total, item) => total + item.quantity, 0)}</span>
                    </div>
                    <div className="cart-summary-row">
                        <span>Доставка:</span>
                        <span>
                            {getTotalQuantity() >= 2 ? (
                                <span className="cart-delivery-free">Безплатна</span>
                            ) : (
                                `до ${DELIVERY_MAX_EUR} €`
                            )}
                        </span>
                    </div>
                    {getTotalQuantity() >= 2 && (
                        <div className="cart-summary-note cart-summary-note--success">
                            Безплатна доставка при 2 или повече артикула в поръчката.
                        </div>
                    )}
                    {getTotalQuantity() < 2 && (
                        <div className="cart-summary-note">
                            Добави още артикули до общо 2 или повече, за да получиш безплатна доставка (до {DELIVERY_MAX_EUR} € при по-малко).
                        </div>
                    )}
                    <div className="cart-summary-row total">
                        <span>Обща сума:</span>
                        <span>{getTotalPrice().toFixed(2)} €</span>
                    </div>
                    <button className="checkout-btn" onClick={handleCheckout}>Продължи към плащане</button>
                    <button onClick={clearCart} className="clear-cart-btn">Изчисти количката</button>
                    <Link to="/" className="continue-shopping">Продължи пазаруването</Link>
                </div>
            </div>
        </div>
    );
};

export default Cart;
